<script setup lang='ts'>
import { APP_ROUTER } from '@qctsw/common'
import { logicMediaNewsRank } from '@/logic/rank/mediaNews'

const props = withDefaults(defineProps<{
  columnId?: number
}>(), {
  columnId: 6,
})
const {
  state,
  data,
  getRankData,
} = logicMediaNewsRank()

await getRankData(props.columnId)
</script>

<template>
  <n-card
    title="媒体报道" embedded size="small"
    class="rounded-md"
    header-style="--n-title-font-weight: bold;"
  >
    <template #header-extra>
      <NuxtLink :to="APP_ROUTER.newsMedia()">
        更多<i class="i-material-symbols:keyboard-double-arrow-right text-4" />
      </NuxtLink>
    </template>
    <UtilLoadState :state="state" :reload-handler="() => getRankData(props.columnId)">
      <template v-if="data && data.length">
        <NuxtLink
          v-for="(v, i) in data" :key="i"
          class="mb-1 text-4 last:mb-0 line-clamp-1 hover:text-orange-6"
          :to="APP_ROUTER.newsDetail(v.id)"
        >
          {{ v.title }}
        </NuxtLink>
      </template>
      <BasicEmpty v-else />
    </UtilLoadState>
  </n-card>
</template>

<style lang='scss' scoped>
</style>
